export default __webpack_public_path__ + "static/media/IMG_20230720_075122_600.f97f7b0d.jpg";